import { countUnreadMessages } from "@/features/tickets/hooks/useUnreadMessages";

interface UnreadMessagesBadgeProps {
  chat: TicketChat[] | undefined;
  className?: string;
  showZero?: boolean;
  maxDisplay?: number;
}

export function UnreadMessagesBadge({ 
  chat, 
  className = "",
  showZero = false,
  maxDisplay = 9
}: UnreadMessagesBadgeProps) {
  const unreadCount = countUnreadMessages(chat);

  if (unreadCount === 0 && !showZero) {
    return null;
  }

  const displayCount = unreadCount > maxDisplay ? `${maxDisplay}+` : unreadCount;

  return (
    <span className={`absolute -right-0.5 -top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-semibold text-white ${className}`}>
      {displayCount}
    </span>
  );
}
